export default __webpack_public_path__ + "f453dd72b702e67cb39c634fa900ed58.png";